import React, { useState } from "react";
import { useNavigate } from "@tanstack/react-router";
import FloatingChatWidget from "./FloatingChatWidget";
import { useAiAnswer, useAiSearch } from "@queries/law.query";
import SearchHeader from "./SearchHeader";
import AiSuggestionBox from "./AiSuggestionBox";
import LawSection from "./LawSection";

function Home() {
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [activeQuery, setActiveQuery] = useState<string>("");
  const navigate = useNavigate();

  const hasQuery = activeQuery.trim().length > 0;

  const { data: aiAnswerData, isLoading: aiAnswerLoading } = useAiAnswer(
    activeQuery,
    hasQuery
  );

  const { data: aiSearchData, isLoading: aiSearchLoading } = useAiSearch(
    activeQuery,
    0,
    hasQuery
  );
  console.log("aiSearchData", aiSearchData);

  const { data: aiSearchData1, isLoading: aiSearchLoading1 } = useAiSearch(
    activeQuery,
    1,
    hasQuery
  );

  const { data: aiSearchData2, isLoading: aiSearchLoading2 } = useAiSearch(
    activeQuery,
    2,
    hasQuery
  );

  const handleSearch = (query: string) => {
    setActiveQuery(query);
  };

  return (
    <div className="min-h-screen bg-white">
      <SearchHeader
        searchQuery={searchQuery}
        onSearchQueryChange={setSearchQuery}
        onSearch={handleSearch}
      />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 md:px-8 pb-8 pt-4 sm:pt-6 md:pt-8 space-y-4 sm:space-y-5 md:space-y-6">
        {hasQuery && (
          <AiSuggestionBox
            content={aiAnswerData?.data || ""}
            isLoading={aiAnswerLoading}
            searchQuery={activeQuery}
          />
        )}

        <LawSection
          title="BỘ LUẬT HÌNH SỰ"
          articles={
            aiSearchData?.data
              ? parseLawData(aiSearchData.data, "BỘ LUẬT HÌNH SỰ")
              : []
          }
          isLoading={aiSearchLoading}
          searchQuery={activeQuery}
        />

        {hasQuery && (
          <LawSection
            title="BỘ LUẬT TỐ TỤNG HÌNH SỰ"
            articles={
              aiSearchData1?.data
                ? parseLawData(aiSearchData1.data, "BỘ LUẬT TỐ TỤNG HÌNH SỰ")
                : []
            }
            isLoading={aiSearchLoading}
            searchQuery={activeQuery}
          />
        )}

        {hasQuery && (
          <LawSection
            title="BỘ LUẬT XỬ LÝ HÀNH CHÍNH"
            articles={
              aiSearchData2?.data
                ? parseLawData(aiSearchData2.data, "BỘ LUẬT XỬ LÝ HÀNH CHÍNH")
                : []
            }
            isLoading={aiSearchLoading}
            searchQuery={activeQuery}
          />
        )}

        {!hasQuery && (
          <div className="text-center py-8 sm:py-12 md:py-16 text-gray-500">
            <p className="text-base sm:text-lg md:text-xl mb-2 md:mb-3">
              Nhập từ khóa để tìm kiếm điều luật
            </p>
            <p className="text-xs sm:text-sm md:text-base">
              AI sẽ hỗ trợ hiểu ngữ nghĩa và trích dẫn điều luật liên quan
            </p>
          </div>
        )}
      </div>

      {/* Floating chat widget */}
      <FloatingChatWidget />
    </div>
  );
}

function parseLawData(
  data: string | any,
  lawCode?: string
): Array<{
  id: string;
  title: string;
  content: string;
  lawCode: string;
}> {
  // Parse logic tùy theo format data từ API
  // Tạm thời return empty array, sẽ cập nhật khi có format chính xác
  try {
    if (typeof data === "string" && data.startsWith("{")) {
      const parsed = JSON.parse(data);
      console.log("parsed", parsed);
      // Handle parsed data structure here
      return [];
    }

    const items = data?.map((item: any) => {
      return {
        id: item.id,
        title: item.title,
        content: item.content,
        lawCode: item.lawCode,
      };
    });

    return items || [];
  } catch (e) {
    // If not JSON, might be plain text
  }
  return [];
}

export default Home;
